var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRestMode = function SvgRestMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4M.2 4.4a1 1 0 0 1 1.4-.2L9.333 10H23a1 1 0 0 1 0 2h-1v3a1 1 0 0 1-2 0v-3H4v3a1 1 0 1 1-2 0v-3H1a1 1 0 1 1 0-2h5L.4 5.8a1 1 0 0 1-.2-1.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.732 3.86a1 1 0 0 1 1.408-.128L10.862 6h.724l3.707-3.707a1 1 0 0 1 1.414 0L20.414 6H22a1 1 0 0 1 0 2H10.5a1 1 0 0 1-.64-.232l-3-2.5a1 1 0 0 1-.128-1.408M17.586 6 16 4.414 14.414 6z",
    clipRule: "evenodd"
  })));
};
export default SvgRestMode;